import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ApiServices from '../Services/ApiServices';
import { toastHelper } from '../../Helpers/toastHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPuzzlePiece, faUser, faHashtag, faSave, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Loader from '../Shared/Loader';

const EditSubscriptionAddon = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { addon } = location.state || {};
    const [submitting, setSubmitting] = useState(false);

    const addonTypes = [
        { value: 1, label: 'حد الطلاب (Students Limit)' },
        { value: 2, label: 'حد الامتحانات (Exams Limit)' },
        { value: 3, label: 'حد المساحة (Storage Limit)' },
        { value: 4, label: 'حد الأسئلة (Questions Limit)' },
        { value: 5, label: 'حد المواد (Materials Limit)' },
    ];

    const customSelectStyles = {
        container: (base) => ({ ...base, width: '100%' }),
        control: (base, state) => ({
            ...base,
            padding: '6px',
            borderRadius: '12px',
            border: state.isFocused ? '2px solid #6366f1' : '2px solid #e2e8f0',
            fontFamily: 'Zain, sans-serif'
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#6366f1' : state.isFocused ? '#f1f5f9' : 'white',
            color: state.isSelected ? 'white' : '#334155',
            fontFamily: 'Zain, sans-serif'
        }),
        singleValue: (base) => ({ ...base, fontFamily: 'Zain, sans-serif' }),
    };

    const formik = useFormik({
        initialValues: {
            user_id: addon?.user_id || '',
            type: addon?.type || 1,
            extra_value: addon?.extra_value || ''
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            type: Yup.number().required('يرجى اختيار نوع الميزة'),
            extra_value: Yup.number().required('يرجى إدخال القيمة').min(1, 'يجب أن تكون القيمة 1 على الأقل')
        }),
        onSubmit: async (values) => {
            setSubmitting(true);
            try {
                const response = await ApiServices.put(`Subscription/User/Addons/update/${addon.id}`, {
                    ...values,
                    extra_value: parseInt(values.extra_value)
                });

                if (response && response.check) {
                    toastHelper.success('تم تحديث الميزة بنجاح');
                    navigate('/admin/dashboard');
                } else {
                    toastHelper.error(response.message || 'فشل في تحديث الميزة');
                }
            } catch (error) {
                toastHelper.error('حدث خطأ أثناء العملية');
            } finally {
                setSubmitting(false);
            }
        }
    });

    if (!addon) {
        navigate('/admin/dashboard');
        return null;
    }

    return (
        <div className="add-addon-page">
            <div className="form-container">
                <header className="form-header">
                    <button className="back-btn" onClick={() => navigate(-1)}>
                        <FontAwesomeIcon icon={faArrowRight} />
                        <span>عودة</span>
                    </button>
                    <h1>تعديل ميزة إضافية</h1>
                </header>

                <form onSubmit={formik.handleSubmit}>
                    <div className="form-grid">
                        <div className="input-group full-width">
                            <label><FontAwesomeIcon icon={faUser} /> المعلم المستفيد</label>
                            <input
                                type="text"
                                value={addon.user_name}
                                disabled
                                style={{ background: '#f8fafc', color: '#64748b', cursor: 'not-allowed' }}
                            />
                        </div>

                        <div className="input-group">
                            <label><FontAwesomeIcon icon={faPuzzlePiece} /> نوع الميزة</label>
                            <Select
                                options={addonTypes}
                                value={addonTypes.find(t => t.value === formik.values.type)}
                                isRtl={true}
                                styles={customSelectStyles}
                                onChange={(opt) => formik.setFieldValue('type', opt.value)}
                            />
                        </div>

                        <div className="input-group">
                            <label><FontAwesomeIcon icon={faHashtag} /> القيمة الإضافية</label>
                            <input
                                type="number"
                                {...formik.getFieldProps('extra_value')}
                                placeholder="مثلاً: 50"
                                className={formik.touched.extra_value && formik.errors.extra_value ? 'input-error' : ''}
                            />
                            {formik.touched.extra_value && formik.errors.extra_value && <div className="field-error">{formik.errors.extra_value}</div>}
                        </div>
                    </div>

                    <footer className="form-footer">
                        <button type="submit" className="submit-btn" disabled={submitting}>
                            <FontAwesomeIcon icon={faSave} spin={submitting} />
                            <span>{submitting ? 'جاري الحفظ...' : 'تحديث الميزة'}</span>
                        </button>
                    </footer>
                </form>
            </div>

            <style>{`
                .add-addon-page { padding: 40px 20px; background: #f8fafc; min-height: 100vh; direction: rtl;   font-family: "Zain", sans-serif; }
                .form-container { max-width: 800px; margin: 0 auto; background: white; padding: 40px; border-radius: 24px; box-shadow: 0 10px 40px rgba(0,0,0,0.05); }
                .form-header { display: flex; align-items: center; gap: 20px; margin-bottom: 40px; border-bottom: 2px solid #f1f5f9; padding-bottom: 20px; }
                .back-btn { background: #f1f5f9; border: none; padding: 10px 20px; border-radius: 12px; cursor: pointer; color: #64748b; font-weight: 700; display: flex; align-items: center; gap: 10px; }
                .form-header h1 { margin: 0; font-size: 1.8rem; color: #1e293b; font-weight: 800; }
                .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 30px; }
                .full-width { grid-column: 1 / -1; }
                .input-group label { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; font-weight: 700; color: #475569; }
                .input-group input { width: 100%; padding: 14px 18px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 1rem;   font-family: "Zain", sans-serif; }
                .input-group input:focus { border-color: #6366f1; outline: none; box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1); }
                .field-error { color: #ef4444; font-size: 0.85rem; margin-top: 8px; font-weight: 700; }
                .form-footer { margin-top: 40px; padding-top: 30px; border-top: 2px solid #f1f5f9; display: flex; justify-content: center; }
                .submit-btn { background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%); color: white; border: none; padding: 16px 50px; border-radius: 15px; font-size: 1.1rem; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 12px; transition: all 0.3s; box-shadow: 0 10px 20px -5px rgba(99, 102, 241, 0.4); }
                .submit-btn:disabled { opacity: 0.7; cursor: not-allowed; }
            `}</style>
        </div>
    );
};

export default EditSubscriptionAddon;
